/**
 * Created by liujintao on 18/10/13.
 */
import api from '@/common/libs/api'
export default {
  state: {
    first: true, //第一次加载的标识
    isTouchEnd: false,  //标示是否已经没有数据了
    noResult: false,   //第一次就没有找到匹配的结果
    coursesList: [], //课程列表
    bannerList: [],
    consultantInfo: {},
    menuList: {},
    conditions: {//查询条件，每次更新时只更新局部条件
      city: '',
      category: '10001',
      teaching_mode: 1001,
      type: '',
      grade: '9',
      phone: '',
      term: '',
      school_nearest: '',
      subject: '',
      pn: 1,  //页数
      rn: 10,    //每页显示课程数
      school_id: '',
      channel: 'izk_mobile',
      version: 99999
    }
  },
  mutations: {
    resetOne(state) {
      state.coursesList = [];
      state.first = true;
      state.isTouchEnd = false;
      state.noResult = false;
      state.conditions = {
        city: '',
        category: '10001',
        teaching_mode: 1001,
        type: '',
        grade: '9',
        phone: '',
        term: '',
        school_nearest: '',
        subject: '',
        pn: 1,  //页数
        rn: 10,    //每页显示课程数
        school_id: '',
        channel: 'izk_mobile',
        version: 99999
      }
    },
    updateCondition(state, conditions) {
      state.conditions = conditions;
    },
    setFaceToFaceList(state, preload) {
      if (preload.isFilter) {
        state.coursesList = preload.content.courses_list;
      } else {
        state.coursesList = state.coursesList.concat(preload.content.courses_list);
      }
      state.consultantInfo = preload.content.consultant_info;
      state.first = false;
    },
    initFaceToFaceList(state, preload) {
      state.conditions = preload.conditions;
      state.coursesList = preload.courses_list;
      state.consultantInfo = preload.consultant_info;
      state.first = false;
      state.noResult = false;
    },
    setFaceToFaceBanners(state, preload) {
      state.bannerList = preload.bannerList;
    },
    setIsEnd(state) {
      if (state.first) {
        state.noResult = true;
      } else {
        state.isTouchEnd = true;
      }
    }
  },
  actions: {
    initFaceToFace({commit, dispatch}, preload) {
      let conditions = preload.conditions;

      return new Promise(function(resolve, reject) {
        api.apiMethod.menuList.post({
          category: conditions.category, //必须有
          teaching_mode: conditions.teaching_mode,
          city: conditions.city,
          channel: 'izk_mobile',
          version: 99999,
          lat: conditions.lat||'',
          lng: conditions.lng||''
        }).then(res => {
          if (res.data.errid == 0 && res.data.content) {
            conditions.school_id = res.data.content.school_default.id;
            conditions.school_nearest = res.data.content.school_nearest;
            api.apiMethod.coursesList.get(conditions).then(resp => {
              if (resp.data.errid == 0) {
                resolve(resp);
              } else {
                reject(resp);
              }
            });
          }
        });
      }).then(resp => {
        //处理后端有时结果返回为null的情况
        if (!resp.data.content) {
          commit('isShowLoading', false);
          dispatch('toast', {title: '网络错误，请刷新页面重试', show: true});
        }
        if (resp.data.errid == 0 && resp.data.content.courses_list.length == 0) {
          commit('setIsEnd', true);

          return;
        }
        commit('initFaceToFaceList', {
          conditions: conditions,
          courses_list: resp.data.content.courses_list,
          banner_list: resp.data.content.banner_list,
          consultant_info: resp.data.content.consultant_info
        });
        preload.$state && preload.$state.loaded();
      }, resp => {
        dispatch('toast', {title: resp.data.errmsg, show: true});
      });

    },
    getFaceToFaceList({commit}, preload) {
      let conditions = preload.conditions;
      commit('updateCondition', conditions);
      return api.apiMethod.coursesList.get(conditions).then(res => {
        if (res.data.errid == 0) {
          if (res.data.content.courses_list.length == 0) {
            commit('setIsEnd', true);
          }
          commit('setFaceToFaceList', {content: res.data.content, isFilter: preload.isFilter ? preload.isFilter : false});
          preload.$state && preload.$state.loaded();
        }
      });
    },
    getFaceToFaceBanners({commit}, conditions) {
      return api.apiMethod.courseBanner.post(conditions).then(res => {
        if (res.data.errid == 0) {
          commit('setFaceToFaceBanners', {bannerList: res.data.content.list});
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/modules/courseCenter/faceToface.js